import { useState } from 'react';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import InvoiceAutomationService from '../../../../Services/InvoiceAutomationService';
import { getRemovedJobs, getSkippedJobs } from '../../../../Helpers/invoiceAutomationRunHelper';

// Runs a project's automatic invoicing on demand. result holds what the run did, skippedJobs the jobs it could not
// add and removedJobs the jobs it took off its drafts, with the reasons it recorded; when the backend refuses,
// runError holds its message.
export default function useInvoiceAutomationRun(projectId) {
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [skippedJobs, setSkippedJobs] = useState([]);
  const [removedJobs, setRemovedJobs] = useState([]);
  const [runError, setRunError] = useState(null);

  function loadRunJobs(invoiceAutomationRunId) {
    return InvoiceAutomationService.GetInvoiceAutomationRunDetail(invoiceAutomationRunId).then((runDetail) => {
      if (!runDetail?.error) {
        setSkippedJobs(getSkippedJobs(runDetail));
        setRemovedJobs(getRemovedJobs(runDetail));
      }
    });
  }

  // runChoices: what the person ticked, the cancelled months to make again and the kinds of out-of-scope jobs to bring
  // in (getRunChoices).
  function run(runChoices) {
    setIsRunning(true);
    setRunError(null);
    ErrorMessage.SetLoading(true);
    InvoiceAutomationService.RunInvoiceAutomation(projectId, runChoices)
      .then((response) => {
        if (response?.error) {
          setRunError(response.error);
          return null;
        }
        setResult(response);
        if (!response.invoiceAutomationRunId || (response.jobsSkipped === 0 && !response.jobsRemoved)) {
          return null;
        }
        return loadRunJobs(response.invoiceAutomationRunId);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage(
          "Error! ErrorCode: UIAR41. The run did not answer. It may still have run: check the project's draft " +
            'invoices before running it again.'
        );
      })
      .finally(() => {
        ErrorMessage.SetLoading(false);
        setIsRunning(false);
      });
  }

  return { run, isRunning, result, skippedJobs, removedJobs, runError };
}
